import { NavbarSeller } from "../Components/Seller";
export function SellerLayout({ children }) {
    return (
      <>
      <NavbarSeller/>
      {children}
      </>
    );
  }
  